/* Cookie consent banner wired to Shopify's Customer Privacy API
   (window.Shopify.customerPrivacy). Real consent state, not a cosmetic
   banner - setTrackingConsent() is what actually gates Shopify's own
   analytics/marketing pixels. Shows only when the API reports the visitor
   hasn't made a choice yet (visitorCanBeTracked/shouldShowBanner semantics
   vary by region; consentCollected covers all regions Shopify requires it in
   and is false elsewhere, when no banner should show at all). */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var initialized = false;

  function init() {
    if (initialized) return;
    var api = window.Shopify && window.Shopify.customerPrivacy;
    var banner = document.querySelector('[data-cookie-consent]');
    if (!api || !banner) return;
    initialized = true;

    function shouldShow() {
      try {
        return typeof api.shouldShowBanner === 'function'
          ? api.shouldShowBanner()
          : !api.currentVisitorConsent || api.currentVisitorConsent().marketing === undefined;
      } catch (e) {
        return false;
      }
    }

    if (!shouldShow()) return;
    banner.hidden = false;

    function setConsent(allowAll) {
      var consent = allowAll
        ? { analytics: true, marketing: true, preferences: true, sale_of_data: true }
        : { analytics: false, marketing: false, preferences: false, sale_of_data: false };
      api.setTrackingConsent(consent, function () {
        banner.hidden = true;
      });
    }

    var acceptBtn = banner.querySelector('[data-cookie-accept]');
    var declineBtn = banner.querySelector('[data-cookie-decline]');
    if (acceptBtn) acceptBtn.addEventListener('click', function () { setConsent(true); });
    if (declineBtn) declineBtn.addEventListener('click', function () { setConsent(false); });
  }

  ready(function () {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      init();
    } else {
      document.addEventListener('visitorConsentCollected', init, { once: true });
      document.addEventListener('trackingConsentApiLoaded', init, { once: true });
      /* Fallback poll: the API script can load after DOMContentLoaded with
         no reliable event in some theme setups - stop after 5s either way. */
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (window.Shopify && window.Shopify.customerPrivacy) {
          clearInterval(poll);
          init();
        } else if (tries > 25) {
          clearInterval(poll);
        }
      }, 200);
    }
  });
})();
